module.exports = __webpack_public_path__ + "img/attribute_mark_6_on.085ac0f.png";